<template>
  <div id="signalsFilter" :class="{ 'logged-in': loggedAndActive }">
    <div class="filter" @click="toggleFilters">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <defs></defs>
        <g transform="translate(-11.019 -7.002)">
          <path
            class="a"
            d="M23.971,19.072"
            transform="translate(-0.663 -0.672)"
          />
          <path
            class="a"
            d="M23.971,19.072"
            transform="translate(-0.663 -0.672)"
          />
          <g transform="translate(15.019 10.002)">
            <rect
              class="a"
              width="15.741"
              height="1.389"
              transform="translate(0.925 1.851)"
            />
            <rect
              class="a"
              width="16.649"
              height="1.389"
              transform="translate(0 8.333)"
            />
            <rect
              class="a"
              width="16.666"
              height="1.389"
              transform="translate(0 14.815)"
            />
            <path
              class="a"
              d="M20.112,12.551A2.546,2.546,0,1,1,17.565,10,2.548,2.548,0,0,1,20.112,12.551Z"
              transform="translate(-15.019 -10.002)"
            />
            <path
              class="a"
              d="M31.1,19.548A2.546,2.546,0,1,1,28.554,17,2.547,2.547,0,0,1,31.1,19.548Z"
              transform="translate(-15.833 -10.521)"
            />
            <path
              class="a"
              d="M24.108,26.548A2.546,2.546,0,1,1,21.561,24,2.547,2.547,0,0,1,24.108,26.548Z"
              transform="translate(-15.315 -11.039)"
            />
          </g>
        </g>
        <rect class="b" width="24" height="24" />
      </svg>
    </div>
    <div class="filter-container" v-show="showFilters">
      <div class="innerFilter">
        <div class="top">
          <span class="title">{{ t("filter_label") }}</span>
          <div class="close" @click="closeFilters">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
            >
              <defs></defs>
              <g transform="translate(0)">
                <g transform="translate(0 0)">
                  <g transform="translate(0 0)">
                    <g transform="translate(0 0)">
                      <rect
                        class="a"
                        width="17.423"
                        height="2.376"
                        transform="translate(0 12.32) rotate(-45)"
                      />
                    </g>
                    <rect
                      class="a"
                      width="17.423"
                      height="2.376"
                      transform="translate(1.68 0) rotate(45)"
                    />
                  </g>
                </g>
              </g>
            </svg>
          </div>
        </div>
        <div class="validityFilter">
          <p class="filterTitle">{{ t("Signal_Validity") }}</p>
          <div class="checkboxes">
            <div class="customCheckBox validity">
              <input
                @change="toggle('validity_hourly')"
                id="validity_hourly"
                type="checkbox"
                checked
              />
              <label for="validity_hourly">{{
                t("Signal_validity_daily")
              }}</label>
            </div>
            <div class="customCheckBox validity">
              <input
                @change="toggle('validity_weekly')"
                id="validity_weekly"
                type="checkbox"
                checked
              />
              <label for="validity_weekly">{{
                t("Signal_validity_weekly")
              }}</label>
            </div>
            <div class="customCheckBox validity">
              <input
                @change="toggle('validity_monthly')"
                id="validity_monthly"
                type="checkbox"
                checked
              />
              <label for="validity_monthly">{{
                t("Signal_validity_monthly")
              }}</label>
            </div>
          </div>
        </div>
        <div class="instrumentsFilter">
          <p class="filterTitle">{{ t("Signal_instruments") }}</p>
          <div class="searchBox">
            <input
              type="text"
              :placeholder="t('Top_Search_Bar')"
              v-model="searchSymbol2"
            />
            <div
              @click="resetSearch()"
              :class="['eraseSearch', { active: searchSymbol2.length > 0 }]"
            >
              X
            </div>
          </div>
          <div
            id="scrollWrapper"
          >
            <div class="checkboxes">
              <div class="customCheckBox">
                <input
                  type="checkbox"
                  id="allInstruments"
                  v-model="selectAll2"
                  @change="toggleSelectAllSymbols"
                />
                <label for="allInstruments">
                  <img
                    src="../assets/images/components/filter/filterAll.svg"
                    width="16"
                    height="16"
                  />
                  {{ t("Signal_select_all") }}
                </label>
              </div>
              <div
                class="customCheckBox"
                v-for="(symbol, index) in searchedSymbols"
                :key="symbol.name + index"
                v-show="checkValidity(symbol.name)"
              >
                <input
                  type="checkbox"
                  :id="symbol.name + index"
                  :checked="symbol.checked"
                  @change="toggleCheckedSymbol(symbol)"
                />
                <label :for="symbol.name + index">
                  <img :src="imgSrc(symbol.image)" width="16" height="16" />
                  {{ symbol.name }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "FilterSignals",
  // props: ["authorisedSignals"],
  computed: {
    ...mapState(["lang"]),
    ...mapState("signals", [
      "symbols",
      "showFilters",
      "signals",
      "validityList",
      "searchSymbol",
      "selectAll"
    ]),
    ...mapActions("signals", ["setSearchSymbol"]),
    ...mapGetters("signals", ["searchedSymbols"]),
    ...mapGetters(["t", "baseImgUrl", "loggedAndActive"]),
    dir: function() {
      if (this.lang === "ar") return "rtl";
      return "ltr";
    },
    searchSymbol2: {
      get: function() {
        return this.searchSymbol;
      },
      set: function(newVal) {
        this.$store.commit("signals/setSearchSymbol", newVal);
      }
    },

    selectAll2: {
      get: function() {
        return this.selectAll;
      },
      set: function(newVal) {
        this.$store.commit("signals/selectAllSymbols", newVal);
      }
    }
  },
  methods: {
    toggleCheckedSymbol(symbol) {
      this.$store.commit("signals/setCheckedSymbol", symbol);
    },
    toggleSelectAllSymbols() {
      this.$store.commit("signals/selectAllSymbols", this.selectAll);
    },

    toggleFilters() {
      this.$store.commit("signals/setShowFilters", !this.showFilters);
    },

    closeFilters() {
      this.$store.commit("signals/setShowFilters", false);
    },

    toggle(validity) {
      this.$store.commit("signals/toggleValidity", validity);
    },

    imgSrc(path) {
      return this.baseImgUrl + path;
    },

    checkValidity: function(symbol) {
      for (const signalValidity of this.symbols[symbol].validity) {
        if (this.validityList.includes(signalValidity)) {
          return true;
        }
      }
      return false;
    },

    resetSearch() {
      this.$store.commit("signals/resetSearch");
    }
  }
};
</script>

<style lang="scss" scoped>
#signalsFilter {
  position: relative;
  #scrollWrapper{
    margin-top: 0.5rem;
  }
  #scrollWrapper .checkboxes{
    overflow: auto;
    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: #808080;
      border-radius: 10px;
    }
  }
  &.logged-in {
    #scrollWrapper .checkboxes{
      height: 230px;
    }
  }
  &:not(.logged-in) {
    #scrollWrapper .checkboxes{
      height: 184px;
    }
  }

  .filter {
    width: 24px;
    height: 24px;
    cursor: pointer;

    svg {
      .a {
        fill: #9e9e9e;
        -webkit-transition: 0.3s;
        transition: 0.3s;
      }

      .b {
        fill: none;
      }
    }

    &:hover {
      svg {
        .a {
          fill: #1c79be;
        }
      }
    }
  }

  .filter-container {
    position: absolute;
    display: flex;
    flex-direction: column;
    width: 22.5rem;
    box-shadow: 1px 3px 6px 0 rgba(0, 0, 0, 0.28);
    background: #fff;
    z-index: 2;
    right: 0;
    margin-top: 4px;

    .top {
      display: none;
      margin-top: 0.25rem;
      margin-bottom: 2.25rem;
      @media only screen and (max-width: 600px) {
        display: block;
      }

      .title {
        font-size: 20px;
        color: #4a4a4a;
      }

      .close {
        :hover {
          cursor: pointer;
        }
        .a {
          fill: #9e9e9e;
        }
      }
    }

    @media only screen and (max-width: 600px) {
      position: fixed;
      top: 60px;
      height: 100vh;
      width: 100vw;
      left: 50%;
      right: 50%;
      margin-left: -50vw;
      margin-right: -50vw;
    }

    .innerFilter {
      margin-top: 1.25rem;
      padding: 0 1.25rem;

      .filterTitle {
        color: #9e9e9e;
      }

      .validityFilter .checkboxes {
        margin: 1.25rem 0 2.5rem;
      }

      .checkboxes .customCheckBox {
        position: relative;
        margin-top: 1.25rem;

        &:last-of-type {
          margin-bottom: 1.25rem;
        }
        &:first-of-type{
          margin-top: 0.75rem; /*together with #scrollwrapper margin-top creating 1.25rem top "gap" as all other rows. intended to make the scrolling behavior a bit more similar to the design*/
        }

        label img {
          margin: 0 0.3125rem;
        }
      }

      .instrumentsFilter {
        .searchBox {
          width: 100%;
          margin: 1.25rem 0 0 0;
        }
      }
    }
  }

  .customCheckBox {
    &.validity {
      input {
        &:checked {
          + label {
            @media only screen and (max-width: 600px) {
              width: 100%;
            }
            &:after {
              @media only screen and (max-width: 600px) {
                position: absolute;
                right: 0.375rem;
                left: unset;
              }
            }
          }
        }
      }
      label {
        &:before {
          @media only screen and (max-width: 600px) {
            position: absolute;
            right: 0;
            margin-right: 0;
            top: 0.125rem;
          }
        }
      }
    }
    input {
      padding: 0 !important;
      height: initial !important;
      width: initial !important;
      margin-bottom: 0 !important;
      display: none !important;
      cursor: pointer;

      &:checked {
        + label {
          color: #424242;
          position: relative;

          &:after {
            content: "";
            display: block;
            position: absolute;
            top: 0.25rem;
            left: 0.375rem;
            width: 0.375rem;
            height: 0.8125rem;
            border: solid #fff;
            border-width: 0 0.125rem 0.125rem 0;
            transform: rotate(45deg);
          }

          &:before {
            background: #1c79be;
            border-color: transparent;
            border-radius: 0.1875rem;
          }

          span.blue {
            color: #1c79be;
            text-transform: uppercase;
          }
        }
      }
    }
    label {
      font-size: 1rem;
      color: #9e9e9e;
      margin-bottom: 0;
      cursor: pointer;

      &:before {
        content: "";
        -webkit-appearance: none;
        background-color: transparent;
        border: 0.125rem solid #9e9e9e;
        padding: 0.4375rem;
        display: inline-block;
        position: relative;
        vertical-align: middle;
        cursor: pointer;
        margin-right: 0.625rem;
        border-radius: 0.1875rem;
        top: -0.125rem;
      }
    }
  }

  .searchBox {
    position: relative;
    display: flex;
    align-items: center;
    width: 18.13rem;
    height: 2.5rem;

    input {
      width: 100%;
      height: 100%;
      padding: 0 0.9375rem 0 2.5rem;
      font-size: 0.875rem;
      background-repeat: no-repeat;
      background-position: 0.3125rem center;
      background-color: transparent;
      background-image: url("../assets/images/components/search_icon.svg");
      color: #9e9e9e;
      border: 1px solid #d5d3d3;
      border-radius: 3px;

      &:hover {
        background-color: #f5f5f5;
      }
    }

    .eraseSearch {
      display: none;
      position: absolute;
      right: 0.625rem;
      cursor: pointer;
      font-size: 0.875rem;
      color: #9e9e9e;

      &.active {
        display: block;
      }
    }
  }
}
.ar {
  #signalsFilter {
    .filter-container {
      @media only screen and (min-width: 600px) {
        right: auto;
        left: 0;
      }
      .close {
        float: left;
      }
    }
    .customCheckBox {
      &.validity {
        input {
          &:checked {
            + label {
              &:after {
                @media only screen and (max-width: 600px) {
                  left: 0.375rem;
                  right: unset;
                }
              }
            }
          }
        }
        label {
          &:before {
            @media only screen and (max-width: 600px) {
              left: 0;
              right: auto;
              margin-left: 0;
            }
          }
        }
      }
      input {
        &:checked {
          + label {
            &:after {
              right: 0.375rem;
              left: auto;
            }
          }
        }
      }
      label:before {
        margin: 0 0 0 0.625rem;
      }
    }
    .searchBox {
      .eraseSearch {
        left: 0.625rem;
        right: auto;
      }
    }
  }
}
</style>
